import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';
import EdgesensorHighRoundedIcon from '@mui/icons-material/EdgesensorHighRounded';
import ViewQuiltRoundedIcon from '@mui/icons-material/ViewQuiltRounded';
import {
  AdminPanelSettingsRounded,
  BusinessCenterRounded,
  CarRentalRounded,
  CastForEducationRounded,
  DirectionsCar,
  EventRounded,
  PartyMode,
  PeopleRounded,
  RunCircle,
  RunCircleRounded,
  SchoolRounded,
} from '@mui/icons-material';
import { useTools } from '../../services/general_services';
import { primaryColor, styles } from '../../assets/styles/styles';
import { RoundedButton } from './RoundedButton';

export default function OurClients({ home }: any) {
  const { theme } = useTools();
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);

  const handleItemClick = (index: number) => {
    console.log('Setting to,', index);
    setSelectedItemIndex(index);
    setSelectedFeature(items[index]);
  };

  const items = [
    {
      icon: (color: any) => {
        return <RunCircle style={{ color: color }} />;
      },

      title: 'Active Communities',
      description:
        'We support running, hiking, cycling, and athletics clubs in creating a safe space for their members to connect & look after each other. ',
      imageLight: 'url("/static/studiotarw.png")',
      imageDark: 'url("/static/studiotarw.png")',
    },
    {
      icon: (color: any) => {
        return <SchoolRounded style={{ color: color }} />;
      },
      title: 'Educational Institutes',
      description:
        'We provide safe spaces for students to access top-tier safety tools around their day-to-day student activities & keep their loved ones in the loop.',
      imageLight: 'url("/static/team.jpg")',
      imageDark: 'url("/static/team.jpg")',
    },
    {
      icon: (color: any) => {
        return <EventRounded style={{ color: color }} />;
      },
      title: 'Festivals & Events',
      description:
        'We help connect hundreds of thousands of attendees to verified site security in emergencies, and give them the offline tools to find safe zones on-site.',
      imageLight: 'url("/static/festival.jpg")',
      imageDark: 'url("/static/festival.jpg")',
    },
  ];

  const [selectedFeature, setSelectedFeature] = React.useState(items[0]);

  return (
    <Grid
      container
      sx={{ backgroundColor: 'white', marginTop: '20px' }}
      justifyContent={'center'}
      alignItems={'center'}
      flexDirection={'column'}
    >
      <Container id="features" style={{ justifyContent: 'center' }}>
        <Grid container>
          <Grid
            item
            xs={0}
            md={6}
            sx={{
              width: '100%',
              border: 0,
              display: { xs: 'none', sm: 'flex' },
            }}
          >
            <Card
              variant="outlined"
              sx={{
                height: '100%',
                width: '100%',
                pointerEvents: 'none',
                border: 0,
              }}
            >
              <Box
                sx={{
                  m: 'auto',
                  height: '100%',
                  width: '100%',
                  aspectRatio: '1 / 1',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  border: 0,
                  backgroundImage: theme =>
                    theme.palette.mode === 'light'
                      ? items[selectedItemIndex].imageLight
                      : items[selectedItemIndex].imageDark,
                }}
              />
            </Card>
          </Grid>
          <Grid item xs={12} md={6} alignItems={'center'} container>
            <Grid
              container
              item
              sx={{ display: { xs: 'auto', sm: 'none' }, marginBottom: '10px' }}
            >
              {items.map(({ title }, index) => (
                <Chip
                  key={index}
                  label={title}
                  onClick={() => handleItemClick(index)}
                  sx={{
                    borderColor: theme => {
                      if (theme.palette.mode === 'light') {
                        return selectedItemIndex === index
                          ? primaryColor
                          : 'white';
                      }
                      return selectedItemIndex === index
                        ? primaryColor
                        : 'rgba(40,40,40)';
                    },
                    borderWidth: '2px',
                    background: theme => {
                      if (theme.palette.mode === 'light') {
                        return selectedItemIndex === index ? 'none' : '';
                      }
                      return selectedItemIndex === index ? 'none' : '';
                    },
                    backgroundColor:
                      selectedItemIndex === index ? primaryColor : 'white',
                    '& .MuiChip-label': {
                      color:
                        selectedItemIndex === index
                          ? 'white'
                          : 'rgba(40,40,40)',
                    },
                    fontFamily: 'Urbanist',
                    fontWeight: '700',
                  }}
                />
              ))}
            </Grid>
            <Box
              component={Card}
              variant="outlined"
              sx={{
                margin: 0,
                display: { xs: 'flex', sm: 'none' },
              }}
            >
              <Box
                sx={{
                  backgroundImage: theme =>
                    theme.palette.mode === 'light'
                      ? items[selectedItemIndex].imageLight
                      : items[selectedItemIndex].imageDark,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  height: '100%',
                }}
              />
              <Grid container>
                <Grid
                  item
                  container
                  xs={2}
                  alignContent={'center'}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  {selectedFeature.icon(primaryColor)}
                </Grid>
                <Grid item container xs={10}>
                  <Box sx={{ px: 2, pb: 2 }}>
                    <Typography
                      color="text.primary"
                      variant="body2"
                      fontWeight="900"
                      sx={{
                        marginTop: { xs: 2, sm: 0 },
                        fontSize: styles.subheader1Size.fontSize,
                        color: primaryColor,
                        fontWeight: 900,
                        textTransform: 'capitalize !important',
                      }}
                    >
                      {selectedFeature.title}
                    </Typography>
                    <Typography
                      color="red"
                      variant="body2"
                      sx={{ my: 0.5, color: 'rgb(40,40,40)' }}
                    >
                      {selectedFeature.description}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              useFlexGap
              sx={{
                width: '100%',
                display: { xs: 'none', sm: 'flex' },
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
              }}
            >
              {items.map(({ icon, title, description }, index) => (
                <Button
                  key={index}
                  onClick={() => handleItemClick(index)}
                  sx={{
                    p: 3,
                    height: 'fit-content',
                    width: '100%',

                    backgroundColor:
                      selectedItemIndex === index ? '#cd0438' : 'white',
                    color:
                      selectedItemIndex === index
                        ? 'white'
                        : 'rgba(40,40,40,1)',
                    '&:hover': {
                      backgroundColor:
                        selectedItemIndex === index ? '#cd0438' : '#fff3f1',
                      color: 'white',
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      textAlign: 'left',
                      flexDirection: { xs: 'column', md: 'row' },
                      alignItems: { md: 'center' },
                      gap: 2.5,
                    }}
                  >
                    <Box
                      sx={{
                        color: theme => {
                          if (theme.palette.mode === 'light') {
                            return selectedItemIndex === index
                              ? primaryColor
                              : 'grey.300';
                          }
                          return selectedItemIndex === index
                            ? 'white'
                            : 'grey.700';
                        },
                      }}
                    >
                      {icon(
                        selectedItemIndex === index
                          ? 'white'
                          : 'rgba(40,40,40,1)'
                      )}
                    </Box>
                    <div>
                      <Typography
                        color={
                          selectedItemIndex === index
                            ? 'white'
                            : 'rgba(40,40,40,1)'
                        }
                        variant="body2"
                        fontWeight="bold"
                        style={{
                          ...styles.subheader2Size,
                          fontWeight: 900,
                          textTransform: 'capitalize',
                        }}
                      >
                        {title}
                      </Typography>
                      <Typography
                        color={
                          selectedItemIndex === index
                            ? 'white'
                            : 'rgba(40,40,40,1)'
                        }
                        variant="body2"
                        sx={{ my: 0.5, textTransform: 'none' }}
                      >
                        {description}
                      </Typography>
                    </div>
                  </Box>
                </Button>
              ))}
            </Stack>
          </Grid>
          <Grid
            item
            xs={12}
            md={0}
            sx={{
              width: '100%',
              border: 0,
              display: { xs: 'flex', sm: 'none' },
            }}
          >
            <Card
              variant="outlined"
              sx={{
                height: '100%',
                width: '100%',
                pointerEvents: 'none',
                border: 0,
              }}
            >
              <Box
                sx={{
                  m: 'auto',
                  height: '100%',
                  width: '100%',
                  aspectRatio: '1 / 1',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  border: 0,
                  backgroundImage: theme =>
                    theme.palette.mode === 'light'
                      ? items[selectedItemIndex].imageLight
                      : items[selectedItemIndex].imageDark,
                }}
              />
            </Card>
          </Grid>
        </Grid>
      </Container>{' '}
      <Button
        style={{
          padding: 20,
          borderRadius: '100px',
          backgroundColor: primaryColor,
          color: 'white',
          paddingLeft: 40,
          paddingRight: 40,
          marginTop: 40,
          width: 'max-content',
        }}
        onClick={() => {
          window.location.href = '/contact';
        }}
      >
        <Typography
          style={{
            color: 'white',
            fontFamily: 'Urbanist',
            fontWeight: '700',
            textTransform: 'none',
          }}
        >
          Get in contact.
        </Typography>
      </Button>
    </Grid>
  );
}
